import { PAGE_SIZE_DEFAULT } from 'utils/constants';

/**
 * Giá trị filter mặc định cho form tìm kiếm
 */
export const initSearchFilters = {
    actived: true,
    deliveryDatePreset: 'Today',
    wasteGroupingContractIds: [],
};

/**
 * Cấu hình tìm kiếm mặc định (bao gồm phân trang và filters)
 */
export const initSearch = {
    paging: {
        pageIndex: 1,
        pageSize: PAGE_SIZE_DEFAULT,
    },
    filters: initSearchFilters,
};

